<!-- IT设备报废申请 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<List :data-val="valData" @child-event='getListVal'></List>
		<a href="/static/export.xlsx" download="export" style="color: #FF0000; text-decoration: underline">下载导入模板</a>
		<!-- <a @click="download" href="javascript:void(0);"  id="attname" class="attname" style="color: #FF0000; text-decoration: underline">下载导入模板</a> -->
		<Button class="submit-process" v-on:click='clickSubmit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import axios from 'axios';
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import List from '../components/List.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	
	import {
			getDepartmentRelationByName,
			getDepartmentRelationById,
			getDepartmentInfo
		} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'
	import {
		getAssetsList,getAssetsListFilter,CheckAssets
	} from '@/api/ccas'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			List
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				formLoading: false,
				listLoading: false,
				valData :{
					TotalCount:0,
					listTitle: [
						{
					        type: 'selection',
					        width: 45,
					        align: 'center',
							fixed: 'left'
					    },
						{
							title: '资产编号',
							key: 'AssetsCode',
							width:120,
							disabled:true
						},
						{
							title: '供应商',
							key: 'SupplierName',
							width:220,
							disabled:true
						},
						{
							title: '规格型号',
							key: 'AssetsSpecMode',
							width:120,
							disabled:true
						},
						{
							title: '资产名称',
							key: 'AssetsName',
							width:180,
							disabled:true
						},
						{
							title: '单位',
							key: 'UnitName',
							width:180,
							disabled:true
						},
						{
							title: '资产类别',
							key: 'AssetsTypeName',
							width:120,
							disabled:true
						},
						{
							title: '位置',
							key: 'DepartPositionName',
							width:120,
							disabled:true
						},
						{
							title: '部门',
							key: 'UseDepartName',
							width:120,
							disabled:true
						},
						{
							title: '价格',
							key: 'AssetsPrice',
							width:70,
							disabled:true
						},
						{
							title: '状态',
							key: 'AssetsStateName',
							width:70,
							disabled:true
						},
						{
							title: '入库日期',
							key: 'InStoreTime',
							width:90,
							disabled:true
						},
						{
							title: '资产级别',
							key: 'AssetsLevelName',
							width:80,
							disabled:true
						},
						{
							title: '资产来源',
							key: 'AssetsSourceName',
							width:80,
							disabled:true
						},
						{
							title: '财务编号',
							key: 'FinancialCode',
							width:120,
							disabled:true
						},
						{
							title: '数量',
							key: 'Number',
							width:90,
							disabled:false
						},
						{
							title: '资产ID',
							key: 'AssetsId',
							width:90,
							disabled:true
						}
					],
					listData: [],
					}
				}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			download() {
				axios.get('static/export.xlsx', {
					responseType: 'blob', //重要
				}).then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					let fname = '导入模板.xlsx';
					link.href = url;
					link.setAttribute('download', fname);
					document.body.appendChild(link);
					link.click();
				});
			},
			clickChoose: async function(dataVal, name) {
				var that=this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
						getDepartmentInfo(depart.id).then(async res=>{
							var departFullName=res.Body.FullName;
							var departs=departFullName.split("/");
							that.templateData.TemplateContent.Controls.forEach(async item=>{
								if (item.Property.Title[0].Text == "申请人逐渐审批") {
									item.IsShow = false;
									item.Values = [];
									if(departs.indexOf("华西区信息中心")==-1){
										item.Values = await that.getDepartmentRelationList(depart.id, 8);
										if(that.logInfo.fullName.indexOf("原友信")>-1){
											if(item.Values != null && item.Values.length>0){
												item.Values.push(["SC14002350","蒋燕"])
											}else{
												item.Values = [["SC14002350","蒋燕"]];
											}
										}
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(that.$store.state.defaultMember);
										}else{
											var isFind=true;
											if(departs.indexOf("住宅部")>0){
												item.Values.forEach(t=>{
													if(t[0]=="HB05010011"){
														isFind=false;
													}
												})
												if(isFind){
													item.Values.push(that.$store.state.defaultMember);
												}
											}
											
										}
									}else{
										item.Values = await that.getDepartmentRelationList(depart.id, 8);
									}
									console.log(item.Values);
								}
							});
						})

					}
				})
			},
			getListVal:async function(data,type){
				var that=this;
				var classId="4b8798d2-91f8-4022-aa40-6ceda965fd78,982bac60-efc5-402e-b74a-789166990ed2";
				if("search" == type){
					await getAssetsList(1,classId,data).then(res=>{
							that.valData.listData=res.Body.Items;
					})
				}else if("changePages" == type){
					await getAssetsList(data,classId,"").then(res=>{
							that.valData.listData=res.Body.Items;
					})
				}else if("changeData" == type){
					this.fromData = data;
				}
			},
			getTemplate:async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var that=this;
				var classId="4b8798d2-91f8-4022-aa40-6ceda965fd78,982bac60-efc5-402e-b74a-789166990ed2";
				await getAssetsList(1,classId,'').then(res=>{
						that.valData.listData=res.Body.Items;
						that.valData.TotalCount=res.Body.TotalCount
				})
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "申请人逐渐审批") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "申请内容") {
							item.IsShow=false;
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			clickSubmit(){
				this.listLoading = true;//显示加载
				let that = this;
				setTimeout(function(){
					that.submit()
				},1000)
			},
			submit:async function() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					this.listLoading = false;//隐藏加载
					return;
				}
				var isSucc=true;
				var code="";
				var tableData=[];
				var startIndex=-1;
				var jsonDataList=[]
				var postData={applyNo:"",applyAccount:this.logInfo.EmpNo,applyAccountName:this.logInfo.EmpName,jsonData:""}
				var that=this;
				if(that.fromData==null||that.fromData.length<=0){
					this.listLoading = false;//隐藏加载
					that.Message({
						message: "请选择或导入资产信息",
						type: 'error',
						duration: 3 * 1000
					});
					return;
				}
				
				var isDelete = false;
				for(let i = this.templateData.TemplateContent.Controls.length-1;i>=0;i--){
					let data = this.templateData.TemplateContent.Controls[i];
					if(data.Property.Title[0].Text.indexOf("申请内容")>-1){
						if(isDelete){
							this.templateData.TemplateContent.Controls.splice(i,1);
						}else{
							isDelete = true;
						}
					}
				}
				
				this.templateData.TemplateContent.Controls.forEach((item,index)=>{
					if (item.Property.Title[0].Text.indexOf("申请内容")>-1) {
						if(that.fromData!=null){
							tableData = that.convertInTable(that.fromData,item);
						}else{
							if(item.Config.Table.Children.length == 0 || !item.IsShow ){
								this.listLoading = false;//隐藏加载
									that.Message({
										message: "请选择或导入资产信息",
										type: 'error',
										duration: 3 * 1000
									});
									return;
							}
						}
						
						startIndex = index;
					}
				});
				
				if(startIndex!=-1){
					var filter = [];
					for(var k = 0; k < tableData.length;k++ ){
						code=tableData[k].Config.Table.Children.filter(t=>t.Property.Title[0].Text=="资产编号")[0].Value;
						filter.push(code);
						if(!isSucc){
							break;
						}
						var jsonData={assetsCode:"",assetsId:"",scrapSourceId:"35ba95fb-1484-4562-a4f4-a6b2318beaa7",scrapSourceName:"其他原因"}
						jsonData.assetsId=tableData[k].Config.Table.Children.filter(t=>t.Property.Title[0].Text=="资产ID")[0].Value;
						jsonDataList.push(jsonData);
						if(k==0){
							this.templateData.TemplateContent.Controls.splice(startIndex,1);
						}
						this.templateData.TemplateContent.Controls.splice(startIndex+k,0,tableData[k]);
					}
					var classCid="4b8798d2-91f8-4022-aa40-6ceda965fd78,982bac60-efc5-402e-b74a-789166990ed2";
					await CheckAssets(filter,classCid).then(res=>{
						if(res.ErrCode == 0 && res.Body){
							that.Message({
								message: '验证成功',
								type: 'success',
								duration: 3 * 1000
							});
						}else{
							isSucc = false;
							that.Message({
								message: res.ErrMsg,
								type: 'error',
								duration: 3 * 1000
							});
							this.listLoading = false;//隐藏加载
							return;
						}
					})
					if(!isSucc){
						this.listLoading = false;//隐藏加载
						return;
					}
				}
				postData.jsonData=JSON.stringify(jsonDataList);
				
				// 1、申请人信息：申请人姓名+工号+部门名称
				// 2、申请部门：申请部门
				// 3、申请原因：申请原因
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0]
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0]
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+" "+control1.Value+" "+control2.Value+" "+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control4.Values[0][1],"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control5=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请原因："+control5.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				
				this.templateData.SummaryList=SummaryList;
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				this.templateData.ScapApply=postData;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					this.listLoading = false;
					this.$router.push("/index");
				}).err(response => {
					this.listLoading = false;
					this.Message({
						message: '申请失败',
						type: 'error',
						duration: 3 * 1000
					});
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
